//$(window).on('load', function(){
//	$('body').addClass('fade_overlay');
//});
$(function(){
	$('body').addClass('fade_out');
  $('a:not([href^="#"]):not([target]):not([data-lightbox]').on('click', function(e){
		$('body').removeClass('fade_overlay');
	});
});
/*
$(function(){
	$('a:not([href^="#"]):not([target])').on('click', function(e){
		e.preventDefault();
		url = $(this).attr('href');
		if(url !== ''){
			$('body').removeClass('fade_overlay');
			setTimeout(function(){
				window.location = url;
			}, 300);
		}
		return false;
	});
});
*/